var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 460,
    viewBox: "0 0 343 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.41 370.512C397.027 321.118 419.907 218.155 370.512 140.538C321.118 62.9211 218.156 40.0417 140.538 89.4358C62.9212 138.83 40.0418 241.793 89.4358 319.41C138.83 397.027 241.793 419.906 319.41 370.512Z",
    fill: "#DFEFEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.212 128.21C246.623 128.267 254.175 129.325 255.037 133.173C255.671 136.014 248.212 194.861 248.212 194.861C248.212 194.861 247.412 196.567 245.529 196.024C243.646 195.48 243.913 193.561 243.913 193.561C243.913 193.561 252.271 136.423 250.933 134.976C249.596 133.53 246.841 133.703 246.41 133.784C245.979 133.863 246.212 128.21 246.212 128.21Z",
    fill: "#6AA3AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.28 315.537L207.202 313.719L206.609 318.307L220.687 320.125L221.28 315.537Z",
    fill: "#005983"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.705 326.529C216.593 327.031 220.168 324.164 220.689 320.126C221.211 316.087 218.482 312.406 214.594 311.904C210.706 311.402 207.131 314.268 206.609 318.307C206.088 322.346 208.817 326.027 212.705 326.529Z",
    fill: "#005983"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.546 197.336L222.468 195.518L207.202 313.719L221.28 315.537L236.546 197.336Z",
    fill: "#6AA3AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236.548 197.337L231.716 196.713L216.45 314.913L221.282 315.537L236.548 197.337Z",
    fill: "#487A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.769 197.753L219.803 195.174L229.061 123.493C229.453 120.459 232.232 118.318 235.27 118.71L244.237 119.868C247.274 120.261 249.418 123.038 249.026 126.071L239.769 197.753Z",
    fill: "#6AA3AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.237 119.868L238.869 119.175C241.906 119.567 244.05 122.344 243.658 125.378L234.4 197.059L239.769 197.753L249.027 126.071C249.418 123.038 247.274 120.261 244.237 119.868Z",
    fill: "#487A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.468 195.518L236.548 197.337L235.269 207.239L222.233 197.34L222.468 195.518Z",
    fill: "#487A80"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M232.322 121.768C231.253 123.106 230.979 124.891 230.74 126.586C230.074 131.327 229.408 136.067 228.744 140.809C228.025 145.936 227.304 151.074 227.084 156.246C227.055 156.929 227.09 157.73 227.653 158.122C228.646 158.815 229.809 157.489 230.237 156.358C233.698 147.219 232.369 137.006 234.192 127.406C234.445 126.074 235.044 124.481 236.391 124.322C237.227 124.224 238.143 124.745 238.877 124.331C240.774 123.26 235.189 118.181 232.322 121.768Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M226.761 161.927C226.375 162.582 226.403 163.39 226.428 164.148C226.54 167.707 226.299 171.275 225.707 174.786C225.562 175.647 225.5 176.74 226.262 177.165C226.851 177.493 227.629 177.166 228.026 176.623C228.423 176.08 228.533 175.385 228.633 174.72C228.991 172.31 229.352 169.9 229.711 167.49C229.944 165.932 230.176 164.351 229.989 162.788C229.805 161.25 227.668 160.38 226.761 161.927Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M210.153 304.672C209.712 308.597 209.268 312.523 208.827 316.448C208.656 317.969 208.588 319.767 209.774 320.738C209.998 320.922 210.269 321.066 210.558 321.071C211.416 321.087 211.802 320.018 211.936 319.169C212.63 314.748 213.211 310.311 213.678 305.861C213.989 302.886 210.562 301.048 210.153 304.672Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13778_69190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.976 213.357L274.079 210.037L243.125 358.231L259.022 361.552L289.976 213.357Z",
    fill: "#F5C15F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.95 213.561L286.557 212.643L255.602 360.838L259.996 361.755L290.95 213.561Z",
    fill: "#DAA33B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.593 367.144L244.943 365.129C243.217 364.768 242.117 363.058 242.482 361.311L243.125 358.231L259.022 361.552L258.378 364.631C258.011 366.378 256.318 367.505 254.593 367.144Z",
    fill: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.765 130.61L299.248 129.249L292.731 127.888C290.384 127.398 287.991 129.341 287.388 132.228L271.259 209.448L282.027 211.697L292.794 213.946L308.924 136.726C309.527 133.839 308.111 131.1 305.765 130.61Z",
    fill: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.765 130.61L303.025 130.038C305.372 130.528 306.787 133.267 306.184 136.154L290.054 213.374L292.794 213.946L308.924 136.726C309.527 133.839 308.112 131.1 305.765 130.61Z",
    fill: "#BAD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.763 137.235L302.588 136.989L286.776 212.687L287.952 212.932L303.763 137.235Z",
    fill: "#BAD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.426 136.12L297.251 135.875L281.439 211.572L282.615 211.817L298.426 136.12Z",
    fill: "#BAD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.266 135.042L292.09 134.797L276.279 210.494L277.454 210.739L293.266 135.042Z",
    fill: "#BAD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.079 210.037L273.681 211.945L287.848 224.64L290.054 213.374L274.079 210.037Z",
    fill: "#DAA33B"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.311 118.373L164.709 116.225L164.222 120.67L183.824 122.818L184.311 118.373Z",
    fill: "#92C5C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.943 127.393C185.352 127.442 192.87 128.348 193.799 132.153C194.483 134.963 188.202 193.556 188.202 193.556C188.202 193.556 187.441 195.265 185.561 194.762C183.681 194.258 183.91 192.347 183.91 192.347C183.91 192.347 191.115 135.432 189.759 134.021C188.405 132.61 185.673 132.835 185.247 132.924C184.821 133.011 184.943 127.393 184.943 127.393Z",
    fill: "#2F7E1D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.821 180.396L158.42 178.38L143.055 318.599L161.456 320.615L176.821 180.396Z",
    fill: "#2F7E1D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.821 180.396L171.138 179.774L155.773 319.993L161.456 320.615L176.821 180.396Z",
    fill: "#26920E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.438 122.857L162.196 120.2L153.661 198.09L177.903 200.746L186.438 122.857Z",
    fill: "#2F7E1D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.438 122.857L176.9 121.812L168.365 199.701L177.903 200.746L186.438 122.857Z",
    fill: "#26920E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.629 320.415L144.814 318.792L144.327 323.237L159.142 324.86L159.629 320.415Z",
    fill: "#92C5C7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.23 198.371C156.23 198.371 175.241 200.213 174.936 200.299C174.63 200.387 173.517 210.544 173.517 210.544L155.917 201.227L156.23 198.371Z",
    fill: "#26920E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M164.606 127.309C163.35 139.649 162.094 151.988 160.838 164.328C160.705 165.637 161.065 167.496 162.376 167.402C162.918 167.364 163.357 166.946 163.687 166.513C165.242 164.479 165.471 161.761 165.673 159.209C166.437 149.578 167.683 139.986 169.404 130.479C169.628 129.245 169.851 127.929 169.369 126.77C168.355 124.331 164.883 124.588 164.606 127.309Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M160.075 176.099C159.555 179.844 159.135 183.603 158.813 187.368C158.649 189.29 158.512 191.245 158.904 193.133C159.007 193.629 159.185 194.169 159.632 194.413C160.146 194.691 160.821 194.427 161.186 193.97C161.55 193.513 161.675 192.914 161.773 192.338C162.681 186.958 162.119 181.31 163.88 176.145C164.219 175.148 164.649 174.086 164.345 173.076C163.117 168.98 160.264 174.738 160.075 176.099Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13778_69190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 242,
    fill: "white",
    transform: "translate(288.48 127) rotate(11.7981)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPens);
export default __webpack_public_path__ + "static/media/pens.b2e448c302d38dce2e6aa40be9967a2e.svg";
export { ForwardRef as ReactComponent };